import { EmailInboxService } from '@/scripts/services/email-inbox/email-inbox-service';

export default {
    data(){
        return {
            hasRequestBeenMade: false
        }
    },

    methods: {
        getIntegrations(callback) {
            if(!this.hasRequestBeenMade){
                this.hasRequestBeenMade = true;
                 EmailInboxService.getIntegratedAccountsDropdown(this.clientId)
                .then((response) => {
                    callback(response.data.data);
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while getting your integrated accounts',
                        { error }
                    );
                })
                .finally(()=>{
                    this.hasRequestBeenMade = false;
                })
            }
        },
    }
}